import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  ServiceTicketError,
  ServiceTicketErrorDetails,
  ServiceTicketStore,
} from '../../../../../@store';
import { CommonStandaloneModule } from '../../../../common-standalone.module';
import { BannerComponent } from '../../../../components';

@Component({
  selector: 'app-service-ticket-detailed-information',
  standalone: true,
  imports: [CommonStandaloneModule, BannerComponent],
  templateUrl: './service-ticket-detailed-information.component.html',
  styleUrls: ['./service-ticket-detailed-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceTicketDetailedInformationComponent implements OnInit, OnDestroy {
  deviceErrors: ServiceTicketError[] = [];

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private serviceTicketStore: ServiceTicketStore, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.serviceTicketStore.boilerDeviceErrorDetails$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((errorDetails: ServiceTicketErrorDetails) => {
        this.deviceErrors = !!errorDetails?.details ? errorDetails?.details : [];
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
